import { getBaseRole } from '@/helpers/customRoles';
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'

export const useFullLeadModalAccess = () => {
  const profile = useSelector(selectProfile)
  const userRole = profile?.role

  const hasFullAccess = getBaseRole(userRole) === 'admin' || getBaseRole(userRole) === 'junior-admin'
  const isHeadOfSales = getBaseRole(userRole) === 'head-of-sales'
  const isSalesManager = getBaseRole(userRole) === 'sales-manager'
  const isAdmin = getBaseRole(userRole) === 'admin'
  const isJuniorAdmin = getBaseRole(userRole) === 'junior-admin'
  const isFranchiseManager = getBaseRole(userRole) === 'franchise-manager'

  return {
    hasFullAccess,

    // Будет отображаться модалка дубликата
    canViewDuplicates: hasFullAccess || isHeadOfSales || isSalesManager,

    // Может видеть нижний блок карточки, блок кнопок
    canViewControlButtons: hasFullAccess || isHeadOfSales || isSalesManager,

    // Может удалять лидов - админы и руководители отдела продаж
    canDelete: hasFullAccess || isHeadOfSales,

    // Может менять данные лида (поля)
    canEditFields:
      hasFullAccess || isHeadOfSales || isSalesManager || isFranchiseManager,

    // Может менять статус лида
    canChangeLeadStatus: hasFullAccess || isHeadOfSales || isSalesManager,

    // Может удалять статус лида
    canDeleteLeadStatus: hasFullAccess || isHeadOfSales || isSalesManager,

    // Может видеть список уведомлений и отправлять их
    canControlNotifications: hasFullAccess || isHeadOfSales || isSalesManager,

    // Взаимодействие с интеграциями (телефония, ТГ и т.д.)
    canInteractWithIntegrations: hasFullAccess || isHeadOfSales || isSalesManager,

    // Возможность привязывать и отвязывать лида от студента
    canBindUnbindStudent: hasFullAccess || isHeadOfSales || isSalesManager,

    // Возможность добавлять покупки
    canAddPurchases: hasFullAccess || isHeadOfSales || isSalesManager,

    // Возможность добавлять и удалять ссылки на покупки
    canManagePurchaseLinks: hasFullAccess || isHeadOfSales || isSalesManager,

    isSalesManager,
    isHeadOfSales,
    isAdmin,
    isJuniorAdmin,

    currentRole: userRole,
  }
}

export default useFullLeadModalAccess
